import React, { useEffect, useState, Children, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import XButton from '../formfields/XButton'

type Props = {
    children: any
    size?: 'small' | 'normal'
    id?: string
}

function ButtonMenu({
    children,
    size = 'normal',
    id
}: Props) {

    const [showMenu, setShowMenu] = useState(false)
    const smallStyles = { width: '30px', height: '30px', padding: '5px', margin: '4px' }
    const normalStyles = { width: '36px', height: '36px', padding: '6px', margin: '6px' }


    return <div className={`${showMenu ? 'z-10' : ''} absolute right-0 top-0`}>
        {!showMenu && <div className={`border-none bg-gray-400 rounded`}
            style={size === 'small' ? smallStyles : normalStyles }>
            <img
                src='/hamburger.svg'
                alt='Menu'
                className={`w-full cursor-pointer`}
                onClick={() => setShowMenu(true)}
                id={id}
                 />
        </div>}
        


        {showMenu && <div
        onMouseLeave={() => setShowMenu(false)}    
        onClick={(e) => {
            const target = e.target as HTMLElement;
          
            // If the clicked element or its ancestor has data-prevent-close, do nothing
            if (target.closest('[data-prevent-close]')) {
              return;
            }
          
            if (
              target.closest('button') ||
              target.closest('a') ||
              target.closest('[role="button"]')
            ) {
              setShowMenu(false);
            }
          }}
            className={`w-full bg-white rounded border border-gray-400 px-3 py-3 shadow`}
            style={{ minWidth: '200px' }}
        >
            <div className={`flex flex-col gap-1`}>
                {children}
            </div>
        </div>}


        
    </div>
}
export default ButtonMenu